import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: 'How Will I Receive the Master Kit?',
    a: "The moment your payment is confirmed, you'll receive an email with instant access to all 9 modules and bonuses in PDF format. No waiting. No shipping. Just open your inbox and start today. Check your spam folder if you don't see it within 5 minutes."
  }, {
    q: 'Is This a Physical or Digital Product?',
    a: 'Vitality 360™ is a 100% digital product. You receive printable PDF files delivered instantly to your email. No shipping costs, no waiting and no risk of lost packages — available anywhere in the world the moment you purchase.'
  }, {
    q: 'Can I Print the Materials?',
    a: 'Absolutely — and we strongly encourage it. The entire system is designed for printing. Large-print format, clear illustrations and fillable tracker pages all work beautifully when printed. Many families keep a binder on the kitchen counter for daily use.'
  }, {
    q: 'Do I Need Medical or Caregiving Experience?',
    a: 'None whatsoever. Vitality 360™ was specifically designed for family members with no medical background. Every activity includes step-by-step instructions written in plain English. If you can read a recipe, you can use this system.'
  }, {
    q: 'Can Professional Caregivers Use It?',
    a: 'Yes — and many do. Professional in-home caregivers use the VIP Module to build structured, level-based activity plans for their clients. Families report feeling more confident knowing their caregiver has a professional system behind their daily work.'
  }, {
    q: 'Is It Suitable for Older Adults With Limited Mobility?',
    a: 'Yes. The entire system was built with limited mobility in mind. The VIP Module starts at Beginner Level with fully seated and bed-based exercises. Module 2 includes chair-based routines specifically designed for older adults who cannot stand safely without support.'
  }, {
    q: 'Can It Be Used Alongside Medical Treatment?',
    a: 'Yes. Vitality 360™ is an educational support resource designed to complement — never replace — professional medical care. The Health Tracker is specifically designed to organize information your doctor needs at every appointment. Always consult your healthcare provider before starting any new exercise or nutrition routine.'
  }, {
    q: 'Are All Three Bonuses Included?',
    a: 'Yes — all three bonuses are included with every purchase at no extra cost. Vital Nutrition 60+, the Family Connection Kit and the Safe Home Checklist are delivered together with your 6 modules the moment your payment is confirmed.'
  }, {
    q: 'Is This a One-Time Payment?',
    a: 'Yes. You pay once and own it forever. No monthly fees. No subscriptions. No hidden charges. Vitality 360™ is yours for life — including any future updates to the 2026 edition.'
  }, {
    q: 'Can I Purchase It Outside the United States?',
    a: 'Yes. Vitality 360™ is available worldwide. The product is delivered digitally by email, so location is never a barrier. Families in Canada, the UK, Australia and across Latin America are already using the system successfully.'
  }, {
    q: 'What Currency Will I Be Charged In?',
    a: "The product is priced in USD at $25. During checkout, the amount is automatically converted to your local currency based on your payment provider's current exchange rate. You will see the exact amount in your currency before confirming your purchase."
  }, {
    q: 'Is There a Money-Back Guarantee?',
    a: "Yes — a full 30-day money-back guarantee. Explore the entire system for 30 days. If you don't feel more organized, more confident and more at peace as a caregiver, contact us for a complete refund. No questions. No hassle. The risk is entirely ours."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-68">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-69">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-70">
          ❓ FREQUENTLY ASKED QUESTIONS
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-71">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-72">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-73">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-74">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-75">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-76">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-77">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10" data-id="element-78">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};